import { Component, signal } from '@angular/core';
import { IInnerHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

/** Params reçus : IHeaderParams fusionnés avec innerHeaderComponentParams. */
export type HeaderTooltipParams = IHeaderParams & { titleTooltip: string };

@Component({
  selector: 'app-header-tooltip',
  standalone: false,
  templateUrl: './header-tooltip.component.html',
  styleUrl: './header-tooltip.component.scss',
})
export class HeaderTooltipComponent implements IInnerHeaderAngularComp {
  readonly displayName = signal<string>('');

  agInit(params: HeaderTooltipParams): void {
    this.refresh(params);
  }

  refresh(params: HeaderTooltipParams): boolean {
    this.displayName.set(params.displayName);

    //tooltip natif sur la cellule header, affiché même si le titre n'est pas tronqué ;
    //mise en forme (titre en gras) par TitleTooltipComponent
    params.setTooltip(params.titleTooltip, () => true);
    return true;
  }
}
